export const GUEST_ID_KEY = 'PGG2_GUEST_ID';

export const GUEST_ID_COOKIE_NAME = ['PGG2_guest_id'];

export const TOAST_MESSAGE_PREFS_TAG_NAME = 'uam/pub/toastMessagePreferences';

export enum AGE_VERIFICATION_STATUS {
    FAILED = 'failed',
    REVIEW = 'review',
    UNKNOWN = 'unknown',
    PASSED = 'passed',
    ACTIVE_GRACE_PERIOD = 'inprocess'
}
